import { blockType, StorageKey } from './const';

const hiddenProperty = (() => {
  let names = [
    'hidden',
    'webkitHidden',
    'mozHidden',
    'msHidden',
  ];
  names = names.filter((e) => (e in document));
  return names.length > 0 ? names[0] : false;
})();

export const visibilityChangeEvent = (() => {
  if (!hiddenProperty) {
    return false;
  }
  return hiddenProperty.replace(/hidden/i, 'visibilitychange');
})();

export const isFocus = () => {
  if (!hiddenProperty) {
    return true;
  }
  return !document[hiddenProperty];
};

export function getNextType() {
  const len = blockType.length;
  return blockType[Math.floor(Math.random() * len)];
}

export function want(next, matrix) {
  const xy = next.xy;
  const shape = next.shape;
  const horizontal = shape.get(0).size;
  return shape.every((m, k1) => (
    m.every((n, k2) => {
      if (xy[1] < 0) { return false; }
      if (xy[1] + horizontal > 10) { return false; }
      if (xy[0] + k1 < 0) { return true; }
      if (xy[0] + k1 >= 20) { return false; }
      if (n) {
        if (matrix.get(xy[0] + k1).get(xy[1] + k2)) {
          return false;
        }
        return true;
      }
      return true;
    })
  ));
}

export function isClear(matrix) {
  const clearLines = [];
  matrix.forEach((m, k) => {
    if (m.every(n => !!n)) {
      clearLines.push(k);
    }
  });
  if (clearLines.length === 0) {
    return false;
  }
  return clearLines;
}

export function isOver(matrix) {
  return matrix.get(0).some(n => !!n);
}

export function subscribeRecord(store) {
  store.subscribe(() => {
    let data = store.getState().toJS();
    if (data.lock) { return; }
    data = JSON.stringify(data);
    data = encodeURIComponent(data);
    if (window.btoa) {
      data = btoa(data);
    }
    localStorage.setItem(StorageKey, data);
  });
}

export function isMobile() {
  const ua = navigator.userAgent;
  const android = /Android/i.test(ua);
  const iphone = /iPhone|iPod|iPad/i.test(ua);
  const nokiaN = /NokiaN/i.test(ua);
  return android || iphone || nokiaN;
}
